import { navigateToUrl } from 'single-spa';

export const forceRedirectDisabledRoute = [
  '/auth/login',
  '/',
  '/auth/v2/login',
  '/home/activity',
  '/silent-check-sso.html',
];

export const adminActivityRoute = '/home/activity';

export const redirectAndRemoveLink = () => {
  const redirectUrl = localStorage.getItem('redirect_uri');
  if (redirectUrl && forceRedirectDisabledRoute.indexOf(redirectUrl) < 0) {
    localStorage.removeItem('redirect_uri');
    navigateToUrl(`${window.location.origin}${redirectUrl}`);
  } else {
    return;
  }
};
export const validateAndSetForceRedirect = async () => {
  if (forceRedirectDisabledRoute.indexOf(window.location.pathname) < 0) {
    localStorage.setItem(
      'redirect_uri',
      `${window.location.pathname}${window.location.search}`
    );
  }
};
